module.exports = __webpack_public_path__ + "static/media/image-2.961c1437.jpg";